import { letsDialSocket } from './LetsDialSocketPlugin'

export interface StreamParams {
  filters?: {
    [key: string]: any
  }
  lastEventId?: string
}

export default function useGetStream<T>(
  stream: string,
  params: StreamParams,
  callback: (data: T) => void,
): { leave: () => void } {
  // letsDialSocket?.emit(`join:${stream}`, params)
  letsDialSocket?.joinStream(stream, params)
  letsDialSocket?.on(stream, callback)
  const leave = () => {
    letsDialSocket?.off(stream, callback)
    letsDialSocket?.leaveStream(stream, params)
    // letsDialSocket?.emit(`leave:${stream}`, params)
  }
  return { leave }
}
